import { BiHighlight } from 'react-icons/bi';
import { GrTextAlignLeft, GrTextAlignCenter, GrTextAlignRight, GrTextAlignFull } from 'react-icons/gr';
import { ImSubscript, ImSuperscript } from 'react-icons/im';
import { RiBold, RiItalic, RiUnderline, RiStrikethrough, RiH1, RiH2, RiH3, RiH4, RiListOrdered, RiListUnordered, RiLink, RiLinkUnlink, RiFormatClear, RiFontColor, RiImageAddLine } from 'react-icons/ri';

import ColorFormatter from './components/ColorFormatter';
import FontSizeFormatter from './components/FontSizeFormatter';
import FormatterIcon from './components/FormatterIcon';
import ImageFormatter from './components/ImageFormatter';
import LinkFormatter from './components/LinkFormatter';
import TableFormatters from './components/TableFormatters';

export const formatters = {
  titleFormatters: editor => {
    if (!editor) return;

    const fontSize = editor.getAttributes('textStyle')?.fontSize

    return (
      <>
        <FontSizeFormatter value={fontSize ? `${fontSize}px` : ''} style={{ width: 'max-content' }} editor={editor} id="tooltip-fontsize" tooltipText="Font size" />
        <FormatterIcon active={editor.isActive('heading', { level: 1 })} icon={RiH1} onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()} id="tooltip-h1" tooltipText="title 1" />
        <FormatterIcon active={editor.isActive('heading', { level: 2 })} icon={RiH2} onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()} id="tooltip-h2" tooltipText="title 2" />
        <FormatterIcon active={editor.isActive('heading', { level: 3 })} icon={RiH3} onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()} id="tooltip-h3" tooltipText="title 3" />
        <FormatterIcon active={editor.isActive('heading', { level: 4 })} icon={RiH4} onClick={() => editor.chain().focus().toggleHeading({ level: 4 }).run()} id="tooltip-h4" tooltipText="title 4" />
      </>
    )
  },
  alignFormatters: editor => {
    if (!editor) return;
    return (
      <>
        <FormatterIcon active={editor.isActive({ textAlign: 'left' })} icon={GrTextAlignLeft} onClick={() => editor.chain().focus().setTextAlign('left').run()} id="tooltip-align-left" tooltipText="align left" />
        <FormatterIcon active={editor.isActive({ textAlign: 'center' })} icon={GrTextAlignCenter} onClick={() => editor.chain().focus().setTextAlign('center').run()} id="tooltip-align-center" tooltipText="align center" />
        <FormatterIcon active={editor.isActive({ textAlign: 'right' })} icon={GrTextAlignRight} onClick={() => editor.chain().focus().setTextAlign('right').run()} id="tooltip-align-right" tooltipText="align right" />
        <FormatterIcon active={editor.isActive({ textAlign: 'justify' })} icon={GrTextAlignFull} onClick={() => editor.chain().focus().setTextAlign('justify').run()} id="tooltip-align-justify" tooltipText="align justify" />
      </>
    )
  },
  specialFormatters: editor => {
    if (!editor) return;
    return (
      <>
        <TableFormatters className="mr-2" editor={editor} id="tooltip-add-table" tooltipText="add table" />
        <ImageFormatter editor={editor} active={editor.isActive('image')} icon={RiImageAddLine} id="tooltip-add-image" tooltipText="add image" />
      </>
    )
  },
  linkFormatters: editor => {
    if (!editor) return;
    return (
      <>
        <LinkFormatter editor={editor} />
        <FormatterIcon icon={RiLinkUnlink} onClick={() => editor.chain().focus().unsetLink().run()} id="tooltip-remove-link" tooltipText="remove link" />
      </>
    )
  },
  listFormatters: editor => {
    if (!editor) return;
    return (
      <>
        <FormatterIcon active={editor.isActive('orderedList')} icon={RiListOrdered} onClick={() => editor.chain().focus().toggleOrderedList().run()} id="tooltip-orderedList" tooltipText="ordered list" />
        <FormatterIcon active={editor.isActive('bulletList')} icon={RiListUnordered} onClick={() => editor.chain().focus().toggleBulletList().run()} id="tooltip-bulletList" tooltipText="bullet list" />
      </>
    )
  },
  scriptFormatters: editor => {
    if (!editor) return;
    return (
      <>
        <FormatterIcon active={editor.isActive('subscript')} icon={ImSubscript} onClick={() => editor.chain().focus().toggleSubscript().run()} id="tooltip-subscript" tooltipText="subscript" />
        <FormatterIcon active={editor.isActive('superscript')} icon={ImSuperscript} onClick={() => editor.chain().focus().toggleSuperscript().run()} id="tooltip-superscript" tooltipText="superscript" />
      </>
    )
  },
  colorFormatters: editor => {
    if (!editor) return;
    return (
      <>
        <ColorFormatter onClick={color => editor.chain().focus().setColor(color).run()} onReset={() => editor.chain().focus().unsetColor().run()} icon={RiFontColor} id="tooltip-color" tooltipText="font color" />
        <ColorFormatter onClick={color => editor.chain().focus().toggleHighlight({ color }).run()} onReset={() => editor.chain().focus().unsetHighlight().run()} icon={BiHighlight} id="tooltip-highlith" tooltipText="background" />
      </>
    )
  },
  markFormatters: editor => {
    if (!editor) return;
    return (
      <>
        <FormatterIcon active={editor.isActive('bold')} icon={RiBold} onClick={() => editor.chain().focus().toggleBold().run()} id="tooltip-bold" tooltipText="bold" />
        <FormatterIcon active={editor.isActive('italic')} icon={RiItalic} onClick={() => editor.chain().focus().toggleItalic().run()} id="tooltip-italic" tooltipText="italic" />
        <FormatterIcon active={editor.isActive('underline')} icon={RiUnderline} onClick={() => editor.chain().focus().toggleUnderline().run()} id="tooltip-underline" tooltipText="underline" />
        <FormatterIcon active={editor.isActive('strike')} icon={RiStrikethrough} onClick={() => editor.chain().focus().toggleStrike().run()} id="tooltip-strike" tooltipText="strike" />
      </>
    )
  },
  clearFormatter: editor => {
    if (!editor) return;
    return <FormatterIcon icon={RiFormatClear} id="tooltip-clear" tooltipText="clear all formats" onClick={() => {
      editor.chain().focus().clearNodes().run();
      editor.chain().focus().unsetAllMarks().run();
    }} />
  },
}
